import type { ApolloClient } from '@apollo/client';
import { Platform } from 'react-native';

import { ADVISOR_IMPERSONATE_CLIENT_ID_KEY } from '@savvy/deprecated-shared/utils/advisor-utils';
import { LocalStorage } from '@savvy/deprecated-shared/utils/local-storage';
import { removeSalesforceAccessToken } from '@savvy/deprecated-shared/utils/salesforce';
import { ADVISOR_IMPERSONATE_HOUSEHOLD_ID_KEY } from '@savvy/utils/advisor-impersonation';

export async function clearUserInfo(apolloClient: ApolloClient<object>) {
  await LocalStorage.removeItem('accessToken');
  if (Platform.OS === 'web') {
    removeSalesforceAccessToken();
    sessionStorage.removeItem(ADVISOR_IMPERSONATE_CLIENT_ID_KEY);
    sessionStorage.removeItem(ADVISOR_IMPERSONATE_HOUSEHOLD_ID_KEY);
  }
  apolloClient
    .clearStore()
    .then(() => {
      // Do nothing
    })
    .catch((e: unknown) => {
      console.error('JWT / Auth Error - error when clearing apollo store', e);
    });
}

export async function isLoggedIn(): Promise<boolean> {
  const accessToken = await LocalStorage.getItem('accessToken');
  return !!accessToken && !isExpiredJWT(accessToken);
}

type JWT = {
  exp: number;
};
export function isExpiredJWT(token: string | null) {
  try {
    if (!token) {
      return false;
    }
    // eslint-disable-next-line typescript/consistent-type-assertions, typescript/no-non-null-assertion -- FIXME: This rule was recently enabled for the repo
    const parsedJWT = JSON.parse(atob(token.split('.')[1]!)) as JWT;
    return parsedJWT.exp < Math.round(new Date().getTime() / 1000);
  } catch (e) {
    console.error(`JWT / Auth Error - error when parsing for expired JWT ${JSON.stringify(e)}`);
    return true;
  }
}
